export default {
  path: '/settlements',
  name: 'settlements',
  component: () => import('../components/Layout'),
  children: [
    {
      name: 'SettlementShow',
      path: ':id',
      component: () => import('../views/settlement/Show')
    }
  ]
}
